import mission1Src from '../../../assets/images/quest/missions/property_1_1.webp';
import mission2Src from '../../../assets/images/quest/missions/property_1_2.webp';
import mission3Src from '../../../assets/images/quest/missions/property_1_3.webp';
import mission4Src from '../../../assets/images/quest/missions/property_1_4.webp';
import mission5Src from '../../../assets/images/quest/missions/property_1_5.webp';
import mission6Src from '../../../assets/images/quest/missions/property_1_6.webp';
import mission7Src from '../../../assets/images/quest/missions/property_1_7.webp';
import mission8Src from '../../../assets/images/quest/missions/property_1_8.webp';
import mission9Src from '../../../assets/images/quest/missions/property_1_9.webp';
import mission10Src from '../../../assets/images/quest/missions/property_1_10.webp';
import mission11Src from '../../../assets/images/quest/missions/property_1_11.webp';
import mission12Src from '../../../assets/images/quest/missions/property_1_12.webp';
import mission13Src from '../../../assets/images/quest/missions/property_1_13.webp';
import mission14Src from '../../../assets/images/quest/missions/property_1_14.webp';
import mission15Src from '../../../assets/images/quest/missions/property_1_15.webp';
import mission16Src from '../../../assets/images/quest/missions/property_1_16.webp';
import mission17Src from '../../../assets/images/quest/missions/property_1_17.webp';
import mission18Src from '../../../assets/images/quest/missions/property_1_18.webp';
import mission19Src from '../../../assets/images/quest/missions/property_1_19.webp';
import mission20Src from '../../../assets/images/quest/missions/property_1_20.webp';
import mission21Src from '../../../assets/images/quest/missions/property_1_21.webp';
import mission22Src from '../../../assets/images/quest/missions/property_1_22.webp';
import mission23Src from '../../../assets/images/quest/missions/property_1_23.webp';
import mission24Src from '../../../assets/images/quest/missions/property_1_24.webp';

export type QuestMissionType = 'deposit' | 'playGames';
export type QuestMissionPrizeType = 'cash' | 'fs' | 'lootbox' | 'tg/wa';

export interface IRawQuestMission {
  date: string;
  title: string;
  type: QuestMissionType;
  mission: string;
  vipMission: string;
  prizeType: QuestMissionPrizeType;
  completeImg: string;
  prizeUrl?: string;
  missionUrl?: string;
  isSpecialMission?: boolean;
}

const bonusesUrl = '/bonuses?tab=active-offers';
const wheelUrl = '/lucky-wheel';
const lobbyUrl = '/';

export const MISSIONS: IRawQuestMission[] = [
  {
    date: '2025-12-01',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: lobbyUrl,
    completeImg: mission1Src,
    prizeUrl: bonusesUrl,
    title: 'missions.0.title',
    mission: 'missions.0.mission',
    vipMission: 'missions.0.vipMission',
  },
  {
    date: '2025-12-02',
    type: 'deposit',
    prizeType: 'lootbox',
    prizeUrl: wheelUrl,
    completeImg: mission2Src,
    title: 'missions.1.title',
    mission: 'missions.1.mission',
    vipMission: 'missions.1.vipMission',
  },
  {
    date: '2025-12-03',
    type: 'playGames',
    prizeType: 'cash',
    missionUrl: lobbyUrl,
    completeImg: mission3Src,
    title: 'missions.2.title',
    mission: 'missions.2.mission',
    vipMission: 'missions.2.vipMission',
  },
  {
    date: '2025-12-04',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/lucky_hits',
    prizeUrl: bonusesUrl,
    completeImg: mission4Src,
    title: 'missions.3.title',
    mission: 'missions.3.mission',
    vipMission: 'missions.3.vipMission',
  },
  {
    date: '2025-12-05',
    type: 'playGames',
    prizeType: 'lootbox',
    missionUrl: '/search-games/merry_spins',
    prizeUrl: wheelUrl,
    completeImg: mission5Src,
    title: 'missions.4.title',
    mission: 'missions.4.mission',
    vipMission: 'missions.4.vipMission',
  },
  {
    date: '2025-12-06',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/new',
    prizeUrl: bonusesUrl,
    completeImg: mission6Src,
    title: 'missions.5.title',
    mission: 'missions.5.mission',
    vipMission: 'missions.5.vipMission',
  },
  {
    date: '2025-12-07',
    type: 'deposit',
    prizeType: 'lootbox',
    prizeUrl: wheelUrl,
    completeImg: mission7Src,
    title: 'missions.6.title',
    mission: 'missions.6.mission',
    vipMission: 'missions.6.vipMission',
  },
  {
    date: '2025-12-08',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/run_win',
    prizeUrl: bonusesUrl,
    completeImg: mission8Src,
    title: 'missions.7.title',
    mission: 'missions.7.mission',
    vipMission: 'missions.7.vipMission',
  },
  {
    date: '2025-12-09',
    type: 'deposit',
    prizeType: 'lootbox',
    prizeUrl: wheelUrl,
    completeImg: mission9Src,
    title: 'missions.8.title',
    mission: 'missions.8.mission',
    vipMission: 'missions.8.vipMission',
  },
  {
    date: '2025-12-10',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: lobbyUrl,
    prizeUrl: bonusesUrl,
    completeImg: mission10Src,
    title: 'missions.9.title',
    mission: 'missions.9.mission',
    vipMission: 'missions.9.vipMission',
  },
  {
    date: '2025-12-11',
    type: 'playGames',
    prizeType: 'cash',
    missionUrl: lobbyUrl,
    completeImg: mission11Src,
    title: 'missions.10.title',
    mission: 'missions.10.mission',
    vipMission: 'missions.10.vipMission',
  },
  {
    date: '2025-12-12',
    type: 'playGames',
    prizeType: 'lootbox',
    missionUrl: '/search-games/instant',
    prizeUrl: wheelUrl,
    completeImg: mission12Src,
    title: 'missions.11.title',
    mission: 'missions.11.mission',
    vipMission: 'missions.11.vipMission',
  },
  {
    date: '2025-12-13',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/bonus_buy',
    prizeUrl: bonusesUrl,
    completeImg: mission13Src,
    title: 'missions.12.title',
    mission: 'missions.12.mission',
    vipMission: 'missions.12.vipMission',
  },
  {
    date: '2025-12-14',
    type: 'deposit',
    prizeType: 'lootbox',
    prizeUrl: wheelUrl,
    completeImg: mission14Src,
    title: 'missions.13.title',
    mission: 'missions.13.mission',
    vipMission: 'missions.13.vipMission',
  },
  {
    date: '2025-12-15',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: lobbyUrl,
    prizeUrl: bonusesUrl,
    completeImg: mission15Src,
    title: 'missions.14.title',
    mission: 'missions.14.mission',
    vipMission: 'missions.14.vipMission',
  },
  {
    date: '2025-12-16',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/lucky_hits',
    prizeUrl: bonusesUrl,
    completeImg: mission16Src,
    title: 'missions.15.title',
    mission: 'missions.15.mission',
    vipMission: 'missions.15.vipMission',
  },
  {
    date: '2025-12-17',
    type: 'deposit',
    prizeType: 'lootbox',
    completeImg: mission17Src,
    prizeUrl: wheelUrl,
    title: 'missions.16.title',
    mission: 'missions.16.mission',
    vipMission: 'missions.16.vipMission',
  },
  {
    date: '2025-12-18',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: '/search-games/new',
    prizeUrl: bonusesUrl,
    completeImg: mission18Src,
    title: 'missions.17.title',
    mission: 'missions.17.mission',
    vipMission: 'missions.17.vipMission',
  },
  {
    date: '2025-12-19',
    type: 'playGames',
    prizeType: 'cash',
    missionUrl: lobbyUrl,
    completeImg: mission19Src,
    title: 'missions.18.title',
    mission: 'missions.18.mission',
    vipMission: 'missions.18.vipMission',
  },
  {
    date: '2025-12-20',
    type: 'playGames',
    prizeType: 'lootbox',
    missionUrl: '/search-games/merry_spins',
    prizeUrl: wheelUrl,
    completeImg: mission20Src,
    title: 'missions.19.title',
    mission: 'missions.19.mission',
    vipMission: 'missions.19.vipMission',
  },
  {
    date: '2025-12-21',
    type: 'deposit',
    prizeType: 'lootbox',
    prizeUrl: wheelUrl,
    completeImg: mission21Src,
    title: 'missions.20.title',
    mission: 'missions.20.mission',
    vipMission: 'missions.20.vipMission',
  },
  {
    date: '2025-12-22',
    type: 'playGames',
    prizeType: 'fs',
    missionUrl: lobbyUrl,
    prizeUrl: bonusesUrl,
    completeImg: mission22Src,
    title: 'missions.21.title',
    mission: 'missions.21.mission',
    vipMission: 'missions.21.vipMission',
  },
  {
    date: '2025-12-23',
    type: 'playGames',
    prizeType: 'cash',
    missionUrl: lobbyUrl,
    completeImg: mission23Src,
    title: 'missions.22.title',
    mission: 'missions.22.mission',
    vipMission: 'missions.22.vipMission',
  },
  {
    date: '2025-12-24',
    type: 'playGames',
    prizeType: 'cash',
    missionUrl: '/search-games/merry_spins',
    prizeUrl: bonusesUrl,
    isSpecialMission: true,
    completeImg: mission24Src,
    title: 'missions.23.title',
    mission: 'missions.23.mission',
    vipMission: 'missions.23.vipMission',
  },
];
